import React from "react";
import {
  Dialog,
  Button,
  DialogContent,
  DialogActions,
  Box,
  Container,
  Grid,
} from "@material-ui/core";
import {
  useObtenerDetalleFacturaTareasQuery,
  useObtenerDetalleFacturaPlanesQuery,
} from "src/services/pagosApi";
import TablaPagosFacturas from "./TablaPagosFacturas";

export default function PagosFacturas(props) {
  const { idFactura, openPagos, setOpenPagos, tipoFactura, folio } = props;
  const { data: pagosTareas = [] } = useObtenerDetalleFacturaTareasQuery(
    idFactura,
    {
      skip: tipoFactura !== "Tareas",
    },
  );

  const { data: pagosPlanes = [] } = useObtenerDetalleFacturaPlanesQuery(
    folio,
    {
      skip: !(tipoFactura !== "Tareas" && folio && folio !== ""),
    },
  );

  const pagos = tipoFactura === "Tareas" ? pagosTareas : pagosPlanes;

  return (
    <div>
      <Dialog
        open={openPagos}
        fullWidth={true}
        aria-labelledby="form-dialog-title"
        maxWidth={"lg"}
      >
        <DialogContent>
          <Box sx={{ width: "100%" }}>
            <TablaPagosFacturas pagos={pagos} />
          </Box>
        </DialogContent>

        <DialogActions>
          <Container>
            <Grid container spacing={1}>
              <Grid item xs={12} sm={7}></Grid>
              <Grid item xs={6} sm={2} justifyContent="flex-end"></Grid>
              <Grid item xs={6} sm={2}>
                <Button
                  fullWidth
                  onClick={() => setOpenPagos(false)}
                  color="primary"
                >
                  Aceptar
                </Button>
              </Grid>
            </Grid>
          </Container>
        </DialogActions>
      </Dialog>
    </div>
  );
}
